import React, { useEffect } from "react";
import ScheduleService from "../../components/ScheduleService/ScheduleService";
import { useTripsCtx } from "../../context/TripDetailsContext";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";

const ScheduleServiceContainer: React.FC = () => {
  const { handleManageServiceUsersData, serviceDataCtx } = useTripsCtx();
  const { isLoadingPersonData } = usePersonSummaryCtx();

  useEffect(() => {
    !isLoadingPersonData &&
      !serviceDataCtx[0].length &&
      handleManageServiceUsersData();
  }, [isLoadingPersonData]);
  
  return <ScheduleService />;
};

export default ScheduleServiceContainer;
